import { snakeCase, camelCase } from 'lodash';

// doesn't format nested keys
export function convertKeysToSnakeCase(obj) {
  if (!obj || Array.isArray(obj)) return obj;
  const newObj = {};
  try {
    Object.keys(obj).forEach((key) => {
      newObj[snakeCase(key)] = obj[key];
    });
  } catch {
    return obj;
  }
  return newObj;
}

// doesn't format nested keys
export function convertKeysToCamelCase(obj) {
  if (!obj || Array.isArray(obj)) return obj;
  const newObj = {};
  try {
    Object.keys(obj).forEach((key) => {
      newObj[camelCase(key)] = obj[key];
    });
  } catch {
    return obj;
  }
  return newObj;
}

function trimTrailingZeros(val) {
  // Allow only strings that are purely numeric (integers or decimals)
  const isPureNumberString =
    typeof val === 'string' && /^-?\d+(\.\d+)?$/.test(val);

  if (typeof val === 'number' || isPureNumberString) {
    return parseFloat(val).toString(); // removes trailing zeroes safely
  }

  return val; // leave strings like "2025-12-12" or "abc" untouched
}

export function formatNumbers(data) {
  if (Array.isArray(data)) {
    return data.map(formatNumbers);
  }

  if (data !== null && typeof data === 'object') {
    return Object.fromEntries(
      Object.entries(data).map(([key, value]) => [key, formatNumbers(value)]),
    );
  }

  return trimTrailingZeros(data);
}
